module.exports = __webpack_public_path__ + "static/media/login.99b94352.jpg";